import type { DataServicePostType } from '../../../types';
import { buildProxyURL } from '../buildProxyUrl';

type GetPostsURLParams = {
  sourcePID: string;
  filters?: FilterParameter[];
  limit?: number;
};

type FilterParameterType = 'include' | 'exclude';

type BaseFilterParameter<T extends FilterParameterType> = {
  type: T;
  username?: string;
  hashtag?: string;
  keyword?: string;
  link?: string;
  from_date?: string;
  post_type?: DataServicePostType | 'reel';
};

export type ExcludeFilterParameter = BaseFilterParameter<'exclude'>;

export type IncludeFilterParameter = BaseFilterParameter<'include'>;

export type FilterParameter = ExcludeFilterParameter | IncludeFilterParameter;

const WIDGET_DATA_SERVICE_SOURCE_LIMIT = 100;

export function getSourceStatusURL(sourcePID: string) {
  return buildProxyURL({
    apiSource: `source/${sourcePID}/status`,
    shouldUseWidgetDataService: true
  });
}

export function getPostsURL({
  sourcePID,
  filters = [],
  limit = WIDGET_DATA_SERVICE_SOURCE_LIMIT
}: GetPostsURLParams) {
  return buildProxyURL({
    apiSource: 'posts',
    params: {
      'sources[]': JSON.stringify({
        pid: sourcePID,
        filters
      }),
      limit: limit.toString()
    },
    shouldUseWidgetDataService: true
  });
}

export function getSourceURL() {
  return buildProxyURL({
    apiSource: 'source/posts',
    shouldUseWidgetDataService: true
  });
}
